import { Injectable } from '@angular/core';
import { CryptoUtils } from '@utils/CryptoUtils';
import { GoogleTagManagerModel } from '../models/google-tag-manager.model';
import { ConfigService } from './config.service';
import { WindowReferenceService } from './window-reference.service';
import { GoogleTagManagerEventEnum } from '../enums/GoogleTagManagerEvent.enum';

@Injectable({
  providedIn: 'root'
})
export class TagManagerService {

  private readonly window;
  private readonly cpfHash: string;
  private readonly cnpjHash: string;

  constructor(private readonly configService: ConfigService, private readonly _windowRef: WindowReferenceService) {
    this.window = _windowRef.nativeWindow;
    let salt = this.configService.getConfig().GA_SALT_CODE;
    this.cpfHash = CryptoUtils.hashWithSaltCode(sessionStorage.cpf, salt);
    this.cnpjHash = CryptoUtils.hashWithSaltCode(localStorage.cnpj, salt);
   }

  pushTag(item: GoogleTagManagerModel) {
    if (item.event === GoogleTagManagerEventEnum.screenView) {
      delete item.element_type;
      delete item.element_content;
    }
    if (item.section_app !== '') {
      item.hash_cnpj = this.cnpjHash;
      item.hash_cpf = this.cpfHash;
      this.window.dataLayer.push(item);
    }
  }
}
